var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncreaseIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39704_83323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.23992 4.93596L6.22392 6.95196L5.45592 5.79996L3.91992 7.33594",
    stroke: "#50C878",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.28027 4.93844H8.24027V5.89844",
    stroke: "#50C878",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.64027 1.33752H7.52027C9.92027 1.33752 10.8803 2.29752 10.8803 4.69752V7.5775C10.8803 9.9775 9.92027 10.9375 7.52027 10.9375H4.64027C2.24027 10.9375 1.28027 9.9775 1.28027 7.5775V4.69752C1.28027 2.29752 2.24027 1.33752 4.64027 1.33752Z",
    stroke: "#50C878",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39704_83323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreaseIcon);
export default __webpack_public_path__ + "static/media/IncreaseIcon.c11c2793129959268a13646068047d29.svg";
export { ForwardRef as ReactComponent };